module.exports = String.fromCharCode(30) + 'f_';



// WEBPACK FOOTER //
// ./lib/internal/f_.js